import {useEffect, useState} from "react";

import { MagneticButton, NeonGlowButton } from "@basatmaqsood/react-buttons";
import imgFlower from './assets/6.png';
import mainLoader from './assets/loader.jpg';
import posterImg from './assets/8.jpg';
import Logo from './assets/logo.png';
import BenderHideImg from './assets/2.png';
import BenderPink from './assets/1.png';

import './App.css';

function App() {
  const [isIntro, setIsIntro] = useState(true);
  const [isBender, setIsBender] = useState(false);

  useEffect(() => {
    const intro = setTimeout(() => {
      setIsIntro(false);
    }, 1500);

    return () => clearInterval(intro);
  }, []);

  const setBenderVisible = (value) => setIsBender(value);


  return (
    <div className="App">

      <div className="PosterWrapper">
        <div className="PosterContainer">
          <img className="ImgFlower" src={imgFlower} style={{ bottom: !isBender ? '0' : '-160px' }} alt="ImgFlower"/>
          <img className="BenderHideImg" src={BenderHideImg} style={{ left: !isBender ? '0' : '-235px' }} alt="BenderHideImg"/>
          <img className="PosterImg" src={posterImg} alt="PosterImg"/>
        </div>
      </div>


      <div className="MainBackgroundToner"></div>

      {isIntro ? (
        <div className="MainLoader">
          <img className="MainLoaderImg" src={mainLoader} alt="mainLoader"/>
        </div>

      ) : (
        <>
          <div className="MainHeaderWrapper">

          </div>

          <div className="MainContentWrapper">
            {/*<img className="FlowerImg" style={{ opacity: isTransparent ? '0' : '1' }} src={imgFlower} alt="imgFlower"/>*/}
            <img className="LogoImg" src={Logo} alt="Logo"/>

            <div className="MainContent">
              <img className="MainContentImg" src={BenderPink} alt="BenderPink"/>
              <div className="MainContentText">
                <span className="MainContentTextItem">Бендер приветствует тебя в магазине Futurama!</span>
                <span className="MainContentTextItem">🚚 Доставка Варшава\Познань 60-90 минут!</span>
                <span className="MainContentTextItem">Всегда свежий и актуальный ассортимент чая☘️, сахара❄️, сахзамов🍬, картона🛣️, успокоительного💊!</span>
                <span className="MainContentTextItem">Постоянные акции и приветливый персонал! Заходи к нам и оставайся.</span>
              </div>
            </div>
          </div>

          <div className="MainFooterWrapper">
            <div
              className="MainButtonWrapper"
              onMouseEnter={() => setBenderVisible(true)}
              onMouseLeave={() => setBenderVisible(false)}
            >
              <MagneticButton
                strength={70}
                radius={300}
                backgroundColor="#6366f1"
                className="w-40 h-12"
              >
                <NeonGlowButton
                  glowColor="#dd840f"
                  glowIntensity={1.5}
                  backgroundColor="#0f172a"
                  className="w-40 h-12 MainButton"
                >
                  Hi, Bender !
                </NeonGlowButton>
              </MagneticButton>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default App;
